import { ref } from 'vue'

/**
 * Dostępność portfela ustalona w CZASIE DZIAŁANIA - to, czego nie da się sprawdzić synchronicznie,
 * zanim paywall się wyrenderuje.
 *
 * Apple Pay ma test synchroniczny (`ApplePaySession.canMakePayments()`), Google Pay **nie ma
 * żadnego**: jedynym źródłem prawdy jest `isReadyToPay()` z `pay.js`, czyli wywołanie sieciowe,
 * które robi dopiero `<google-pay-button>` po zamontowaniu. Do tej chwili kanał wygląda na dostępny,
 * bo warunek, który sprawdzaliśmy (`window.isSecureContext`), jest spełniony na każdej stronie
 * po HTTPS - także na urządzeniu, które Google Pay w ogóle nie obsługuje.
 *
 * Dlatego użytkownik na iOS wchodził w kanał, który nigdy nie wystawił przycisku: biblioteka zostawia
 * element z klasą `not-ready` (własny CSS: `width: 0; height: 0`), a fakt zgłasza WYŁĄCZNIE eventem
 * `readytopaychange`. Bez jego obsługi nie było ani przycisku, ani komunikatu, ani zdarzenia
 * w Sentry (SDKN-111, zgłoszenie zespołu mobilnego).
 *
 * Wynik zapisujemy w `ref`, nie w zwykłej zmiennej modułowej: `ToolsClass.isWalletPaywayAvailable()`
 * czytają `computed` w `PaywayList.vue` i `PaywayGroup.vue`, więc bez reaktywności kafel nie
 * przerysowałby się po ustaleniu odpowiedzi.
 */
const googlePayUnavailable = ref(false)

/**
 * Czy `isReadyToPay()` już odpowiedziało, że przycisku Google Pay nie będzie.
 * @returns {boolean}
 */
export const isGooglePayRuntimeUnavailable = () => googlePayUnavailable.value

/**
 * Zapisuje odpowiedź `isReadyToPay()`. Wołane wyłącznie z `GooglePay.vue`.
 *
 * Ustawienia nie cofamy: flaga dotyczy urządzenia i przeglądarki, a nie stanu transakcji, więc
 * w obrębie jednej wizyty odpowiedź nie ma jak się zmienić.
 */
export const markGooglePayRuntimeUnavailable = () => {
  googlePayUnavailable.value = true
}

/**
 * Zeruje stan. Wyłącznie dla testów - flaga jest modułowa, więc bez tego przeciekałaby
 * między przypadkami.
 */
export const resetWalletRuntimeAvailability = () => {
  googlePayUnavailable.value = false
}
